module.exports = __webpack_public_path__ + "static/media/Agenda12.3c172e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda12.png
// module id = 1976
// module chunks = 0